import { Col, Radio, Row } from "antd";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { useLocation } from "react-router-dom";
import LoadingComp from "../../components/common/LoadingComp";
import axiosGeneral from "../../utils/axiosGeneral";
import axiosWithAuth from "../../utils/axiosWithAuth";
import ListingItem from "./ListingItem";

export default function EventListing(props) {
  const {
    setCartData,
    cartData,
    setUpdateModalData,
    updateModalData,
    onlinePurchasedTickets,
    user,
  } = props;

  const [events, setEvents] = useState([]);
  const [eventsLength, setEventsLength] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const [filterCurrentPage, setFilterCurrentPage] = useState(1);
  const [sorting, setSorting] = useState("date");
  const [value, setValue] = useState("asc");
  const search = useLocation().search;

  const location = new URLSearchParams(search).get("location");
  const category = new URLSearchParams(search).get("category");
  const keyword = new URLSearchParams(search).get("keyword");
  let categoryQuery = category ? `&category=${category}` : "";
  let locationQuery = location ? `&location=${location}` : "";
  let eventNameQuery = keyword ? `&keyword=${keyword}` : "";

  useEffect(() => {
    const getToken = JSON.parse(localStorage.getItem("token"));
    if (getToken && "token" in getToken) {
      setIsLoggedIn(true);
    }
  }, []);

  const fetchEvents = (page = 1, sort = sorting, order = value) => {
    setLoading(true);
    setIsLoader(true);

    let searchFlag = location || category || keyword;

    let APIURL = `/api/event/?searchDataPage=${page}${locationQuery}${categoryQuery}&sort=${sort}&OrderBy=${order}${eventNameQuery}`;

    axiosGeneral()
      .get(APIURL)
      .then((res) => {
        if (res.status === 200 && res.data.events) {
          if (page === 1) {
            setEvents(res.data.events);
          } else {
            setEvents((prevEvents) => [...prevEvents, ...res.data.events]);
          }
          setEventsLength(res.data.length);
          if (res.data.events.length === 0 || res.data.events.length < 12) {
            setLoading(false);
          }
          if (searchFlag) {
            setFilterCurrentPage(page);
          } else {
            setCurrentPage(page);
          }
          setUpdateModalData((prevData) => [...prevData, ...res.data.events]);
        }
        setIsLoader(false);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  useEffect(() => {
    fetchEvents();
  }, [search, sorting, value]);

  useEffect(() => {
    if (isLoggedIn && user && user.id) {
      getUserData();
    }
  }, [user]);

  const getUserData = async () => {
    const response = await axiosWithAuth().get(`/api/users/${user.id}`);
    if (response && response.status === 200) {
      setUserData(response.data);
    }
  };

  const loadMoreEvents = () => {
    let nextPage = currentPage + 1;
    if (location || category || keyword) {
      fetchEvents(nextPage, sorting, value);
    } else {
      fetchEvents(nextPage, sorting, value);
    }
  };

  const handleSorting = (val) => {
    setSorting(val);
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  if (isLoader) {
    return <div className="loader" id="loader"></div>;
  } else {
    return (
      <div id="event-listing" className="listing-page">
        <div className="listing-header">
          <h4 className="results-num">
            Found {events.length} of {eventsLength} Results
          </h4>
          <div className="sort-form">
            <form>
              <label>
                <span>Sort By</span>
                <select
                  value={sorting}
                  onChange={(e) => handleSorting(e.target.value)}
                >
                  <option value="name">Name</option>
                  <option value="date">Date</option>
                </select>
              </label>
            </form>
            <Radio.Group onChange={onChange} value={value}>
              <Radio value="asc" className="radioVal">
                ASC
              </Radio>
              <Radio value="desc" className="radioVal">
                DESC
              </Radio>
            </Radio.Group>
          </div>
        </div>
        <InfiniteScroll
          pageStart={0}
          loadMore={loadMoreEvents}
          hasMore={loading}
          loader={<LoadingComp />}
        >
          <div className="bizzll-events">
            {events.map((event) => (
              <ListingItem
                key={event.id}
                user={user}
                event={event}
                userData={userData}
                setCartData={setCartData}
                cartData={cartData}
                onlinePurchasedTickets={onlinePurchasedTickets}
              />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}
